<template>
  <div class="my">
    <!--头部-->
    <Navbar :isNotify="false" :isCustomerService="false" :showLeft="false">
      <template #left>
        <div class="left-content">
          <img
            class="guide-logo-icon"
            src="@/assets/style/home-title-bg.png"
            alt=""
          />
          <div class="text">
            <span style="font-weight: 600">新享管家</span>
            <span class="tip">应急周转 秒批秒到更省心</span>
          </div>
        </div>
      </template>
      <template #right>
        <div class="right-content">
          <img
            @click="handleClickNotify"
            class="notifyIcon"
            src="@/assets/style/notify-icon.png"
            alt=""
          />
          <img
            @click="handleClickCustomerService"
            class="customerServiceIcon"
            src="@/assets/style/customer-service-icon.png"
            alt=""
          />
        </div>
      </template>
    </Navbar>
    <!--内容区域-->
    <div class="content">
      <!--用户信息-->
      <userInfo />
      <!--菜单列表-->
      <menuList />
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/navbar/index.vue";
import userInfo from "@/components/my/userInfo.vue";
import menuList from "@/components/my/menuList.vue";
import { getPersonalInfo } from "@/api/index";

export default {
  name: "My",
  components: {
    userInfo,
    menuList,
    Navbar,
  },
  data() {
    return {};
  },
  async mounted() {
    //获取个人信息
    const res = await getPersonalInfo();
    if (res.code === 2000) {
      this.$store.commit("setUserInfo", {
        ...this.$store.state.userInfo,
        ...res.data,
      });
    }
  },
  methods: {
    handleClickNotify() {
      this.$router.push({ name: "notify" });
    },
    handleClickCustomerService() {
      if (process.env.VUE_APP_ENV === "productionApp") {
        this.$JSBridge.send("serviceType", { type: "8" });
      } else {
        const fromUrl = window.location.href;
        const urlTitle = document.title;
        const nickName = this.userInfo?.username || "";
        const clientId = localStorage.getItem("phone")? `phone_${localStorage.getItem("phone")}` : "";
        window.open(
          `https://ykf-weixin01.7moor.com/wapchat.html?accessId=f12bce20-49ee-11f1-aea3-c5caf3f64abe&fromUrl=${fromUrl}&urlTitle=${urlTitle}&language=ZHCN&nickName=${nickName}&clientId=${clientId}`,
        );
      }
    },
  },
  computed: {
    userInfo(){
      return this.$store.state.userInfo;
    }
  },
};
</script>

<style scoped lang="scss">
.my {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow-y: auto;
  background: linear-gradient(180deg, #0d63ef 5%, #1d70f7 15.56%, rgba(211, 227, 253, 0.2) 48.17%, rgba(255, 255, 255, 0) 100%)
}
.my.is-overlapped {
  ::v-deep(.van-nav-bar) {
    background: #0d63ef !important;
  }
  ::v-deep(.van-nav-bar__title) {
    color: #fff;
  }
}
::v-deep(.van-nav-bar__content) {
  height: 56px !important;
}
::v-deep(.van-nav-bar) {
  background: transparent !important;
}
::v-deep(.van-nav-bar) {
  background: transparent !important;
}
.left-content {
  display: flex;
  font-size: 18px;
  font-family: "Regular";
  color: #fff;
  align-items: center;
  .guide-logo-icon {
    height: 32px;
  }
  .text {
    padding-left: 3px;
    display: flex;
    flex-direction: column;
  }
  span {
    text-align: left;
  }
  .tip {
    font-size: 11px;
    margin-top: -5px;
  }
}
.right-icons {
  display: flex;
}
.notifyIcon {
  width: 24px;
  height: 24px;
}
.content {
  margin-top: 14px;
  padding: 0 16px;
}
.customerServiceIcon {
  width: 24px;
  height: 24px;
  padding-left: 24px;
}
</style>
